import { render, staticRenderFns } from "./formgroupquestion.vue?vue&type=template&id=a1a7395c&"
import script from "./formgroupquestion.vue?vue&type=script&lang=js&"
export * from "./formgroupquestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports